// directives/v-intersect.js

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.directive('intersect', {
    mounted(el, binding) {
      const options = {
        root: null, // default is the viewport
        rootMargin: '0px',
        threshold: 0.5, // Trigger when 50% of the element is visible
      };

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            if (binding.value && typeof binding.value === 'function') {
              binding.value(true); // Pass true when intersecting
            } else if (typeof binding.arg === 'string') {
              el.classList.add(binding.arg); // Add class specified in argument
            } else {
              el.classList.add('is-visible'); // Default class
            }
            // Optionally, unobserve after the first intersection if you only need it once
            // observer.unobserve(el);
          } else {
            if (binding.value && typeof binding.value === 'function') {
              binding.value(false); // Pass false when not intersecting
            } else if (typeof binding.arg === 'string') {
              el.classList.remove(binding.arg); // Remove class when not intersecting
            } else {
              el.classList.remove('is-visible'); // Remove default class
            }
          }
        });
      }, options);

      observer.observe(el);

      // Store the observer on the element to unobserve when the element is unmounted
      el.__vue_intersect_observer__ = observer;
    },
    unmounted(el) {
      // Clean up the observer when the element is removed from the DOM
      if (el.__vue_intersect_observer__) {
        el.__vue_intersect_observer__.disconnect();
        delete el.__vue_intersect_observer__;
      }
    },
  });
});